import React from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import ResultHeader from "./ResultHeader";
import "../../assets/styles/sub-table.css";
import DriverLicense from "./DriverLicense";
import { getMenuItem } from "../common/PageHelper";

class DriverLicenseResult extends React.Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const results = [];
    let tabHeader;
    if (
      props.searchResultData !== undefined &&
      props.searchResultData !== null &&
      props.searchResultData !== ""
    ) {
      const crimResults = _.get(
        props.searchResultData,
        "drivers.DLSearch2Response[0].records[0].record"
      );
      const showNarrowSearchMessage = crimResults && crimResults.length > 25;
      tabHeader = (
        <ResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          {...this.props}
        />
      );

      if (crimResults)
        _.forEach(crimResults, (crimRes, criIndex) => {
          const colorClass = criIndex % 2 === 0 ? "odd-row" : "even-row";
          results.push(
            <Table.Row key={`Crim_Row_${criIndex}`} className={colorClass}>
              <Table.Cell>
                <DriverLicense
                  key={`Crim_Table_${criIndex}`}
                  node={crimRes}
                  index={criIndex}
                  {...props}
                />
              </Table.Cell>
            </Table.Row>
          );
        });
    }
    const selectedRows = [];
    for (let index = 0; index < props.resultRecordCount; index += 1) {
      selectedRows[index] = false;
    }
    this.state = {
      selectedRows,
      results,
      tabHeader,
    };
  };

  render() {
    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${
          this.state.results.length > 0 ? this.state.results.length : 0
        } Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {this.state.tabHeader}
          {this.state.results.length > 0 && (
            <Table stackable>
              <Table.Body>{this.state.results}</Table.Body>
            </Table>
          )}
        </Tab.Pane>
      ),
    });
    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(DriverLicenseResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/DriverLicensesResult.js